// APPLICATION CONTROL FLIPPERS - DO NOT DELETE THESE FLIPPERS
export const SENTRY_EVERY_REQUEST = 'sentry_every_request';
export const CSP_REPORTING = 'csp_reporting';
export const EXTENDED_API_LOGGING = 'extended_api_logging';
export const PENDO_ENABLED = 'pendo_enabled';
export const UNDER_MAINTENANCE = 'under_maintenance';
export const SENTRY_MONITORING = 'sentry_monitoring';
export const EMAIL_DOMAIN_BLACKLIST = 'email_domain_blacklist';

// ROLLED OUT FLIPPER FLAGS TO DELETE
export const HLL_SKETCH_UNIQUES = 'hll_sketch_uniques';
export const ROKU_SAN = 'roku_san';
export const TIKTOK_AUTH = 'tiktok_auth';
export const IOS14_CALCULATE_ORGANIC_SETTINGS = 'ios14_calculate_organic_settings';
export const SKADNETWORK_FACEBOOK_ENDPOINTS = 'skadnetwork_facebook_endpoints';
export const APPLE_OAUTH2 = 'apple_oauth2';
export const HYDRA_OAUTH2 = 'hydra_oauth2';
export const HIGHCHARTS_SUMMARY_PAGE = 'highcharts_summary_page';
export const JOURNEY_PRIORITY_POPOVER = 'journey_priority_popover';
export const ENGAGEMENT_BUILDER_AD_PARTNER_INTEGRATION = 'engagement_builder_ad_partner_integration';
export const FACEBOOK_INSTALL_REFERRER = 'facebook_install_referrer';
export const ENABLE_ADVANCED_CONVERSION_FOR_SNAP = 'enable_advanced_conversion_for_snap';
export const NEW_POSTBACKS_FORM = 'new_postbacks_form';
export const ENABLE_TIKTOK_SAN = 'enable_tiktok_san';
export const ENABLE_HUAWEI_AD_PARTNER = 'enable_huawei_ad_partner';
export const UNIFIEDSKANVIEW = 'unifiedskanview';
export const QR_CODE_DEEPVIEW = 'qr_code_deepview';
export const NEW_POSTBACKS_MACROS = 'new_postbacks_macros';
export const NEW_WEBHOOKS_MACROS = 'new_webhooks_macros';
export const VERSIONING_SERVICE = 'versioning_service_integration';
export const HIGHCHARTS_MIGRATION = 'highcharts_migration';
export const SKAD_NETWORK_SKAN4 = 'skad_network_skan4';
export const ADS_FRAUD_HIGHCHARTS = 'ads_fraud_highcharts';
export const GOOGLE_ANALYTICS_V4 = 'google_analytics_v4';
export const USAGE_AND_QUOTAS = 'usage_and_quotas';
export const FACEBOOK_AEM_SUPPORT = 'facebook_aem_support';
export const DISCO_DASHBOARD = 'disco_dashboard';
export const ERROR_HANDLING = 'error_handling';
export const RECAPTCHA_FOR_BRANCH_KEY = 'recaptcha_for_branch_key';
export const HIDE_BRANCH_KEY_RECAPTCHA_FOR_VALID_CREDIT_CARD = 'hide_branch_key_recaptcha_for_valid_credit_card';
export const HIDE_LINK_CONFIGURATION_FROM_ONBOARDING = 'hide_link_configuration_from_onboarding';
export const ALLOW_ACCOUNT_CREATION_ON_MX_SERVER_NOT_FOUND = 'allow_account_creation_on_mx_server_not_found';
export const COHORTS_UI_REFRESH = 'cohorts_ui_refresh';
export const RESTRICT_SNAP_REPORTS = 'restrict_snap_reports';
export const JOURNEY_CREATIVES_HTML_EDITOR_TAB = 'journey_creatives_html_editor_tab';
export const LIGHTWEIGHT_FILTERS_FOR_EMAIL = 'enable_lightweight_filters_for_email';
export const BRANCH_ACCOUNT_SETTINGS = 'branch_account_settings';
export const BRANCH_ACCOUNT_ACTIONS = 'branch_account_actions';
export const ROI_HUB_MENU_ITEM_SHOW = 'roi_hub_menu_item_show';
export const HOUSEHOLD_MEASUREMENT_WINDOW = 'household_measurement_window';
export const SAN_UI_CONNECTION_IMPROVEMENTS = 'san_ui_connection_improvements';
export const SAN_UI_PARTNER_IMPROVEMENTS = 'san_ui_partner_improvements';
export const BILLING_CONTRACT_INVOICE = 'billing_contract_invoice';
export const SUPPORT_APP_VERSION_IN_ANALYTICS = 'support_app_version_in_analytics';
export const SKAN_UNIFIED_CURRENCY_SWITCHER = 'skan_unified_currency_switcher';
export const SKAN_CONVERSION_CENTER_IMPROVED_MAPPINGS = 'skan_conversion_center_improved_mappings';
export const PAM = 'predictive_aggregate_measurement';
export const DARKLY_NAVIGATION = 'darkly_navigation';

// OLDER FLIPPER FLAGS THAT ARE NOT ENABLED - Need investigation to see if they are still needed
export const NON_SANS_DATA_SHARING_TOGGLE = 'non_sans_data_sharing_toggle';
export const DRUID_RATE_LIMIT_MODAL = 'druid_rate_limit_modal';
export const MATCH_CAMPAIGN_ID_FOR_EO_DATA = 'match_campaign_id_for_eo_data';
export const OTT_ADS_ACTIVITY_PAGE = 'ott_ads_activity_page';
export const DISABLE_AMAZON_POSTBACKS = 'disable_a_amazon_ad_partner';
export const SELF_SERVE_USAGE_WARNINGS = 'self_serve_usage_warnings';

export const EO_MIGRATION = 'eo_migration';
export const EO_OPTED_OUT_LIST = 'eo_opted_out_list';
export const VIEW_ALL_AD_PARTNERS = 'view_all_ad_partners';
export const FORCE_EO_HIDE_TRANSITION_ELEMENTS = 'force_eo_hide_transition_elements';
export const CUSTOM_EXPORTS_TUNE = 'custom_exports_tune'; // ON => TUNE fields and topics; OFF => Branch fields and topics for CEUI
export const INSTALL_TOUCH_ATTRIBUTION = 'install_touch_attribution';
export const TWO_YEAR_DATA_RETENTION = 'two_year_data_retention';
export const DISCOVERY_ADS_UI = 'discovery_ads_ui';
export const ADNETWORKDATAFILTERING = 'adnetworkdatafiltering';
export const ALLOW_EO_SAN_TOUCH_EXPORT = 'allow_eo_san_touch_export';
export const ENGAGEMENT_BUILDER = 'engagement_builder';
export const USE_CUSTOM_DOMAIN_FOR_AD_LINK = 'use_custom_domain_for_ad_link';
export const SHORTER_DEFAULT_DRUID_QUERY_DURATION = 'shorter_default_druid_query_duration';
export const APPEND_WEB_FLIPPER = 'append_web_flipper';
export const DISPLAY_COST_ON_SKADNETWORK = 'display_cost_on_skadnetwork';
export const REDUCED_DEFAULT_FILTER_RANGE_DRUID = 'reduced_default_filter_range_druid';
export const EXTEND_CONVERSION_EVENT_WINDOW_DAYS_LIMITS = 'extend_conversion_event_window_days_limits';
export const SHOW_DATA_FEEDS_WEBHOOK_HEADERS_AND_BODY = 'show_data_feeds_webhook_headers_and_body';
export const ACCESSIBE = 'accessibe';
export const LINK_MANAGER = 'link_manager';
export const HAS_BACKDATED_EVENTS = 'has_backdated_events';
export const OTT = 'ott';
export const OTT_SUMMARY_PAGE = 'ott_summary_page';
export const PROTECTED_DOWNLOADS = 'protected_downloads';
export const AD_LINK_MANAGER = 'ad_link_manager';
export const AD_LINK_TEMPLATES = 'ad_link_templates';
export const BULK_AD_LINKS = 'bulk_ad_links';
export const BULK_QUICK_LINKS = 'bulk_quick_links';
export const QUICK_LINK_MANAGER = 'quick_link_manager';
export const QUICK_LINK_TEMPLATES = 'quick_link_templates';
export const DELETE_LINK_TEMPLATES = 'delete_link_templates';
export const BRANCH_ACCOUNT_TEAM = 'branch_account_team';
export const BRANCH_ACCOUNT_TEAM_ACTIONS = 'branch_account_team_actions';
export const CUSTOM_QR_JOURNEYS = 'custom_qr_journeys';
export const ROI_HUB = 'roi_hub';
export const ROI_HUB_INTERNAL = 'roi_hub_internal';
export const SSO_STRICT = 'sso_strict';
export const HOUSEHOLD_MEASUREMENT_WINDOW_NON_OTT_AD_PARTNERS = 'household_measurement_window_non_ott_ad_partners';
export const USE_SUB_APP_INVOICE = 'use_sub_app_invoice';
export const GOOGLE_ADS_MULTI_AUTHENTICATION = 'google_ads_multi_authentication';
export const RESTRICT_PREMIUM_TRIALS_SS = 'restrict_premium_trials_ss';
export const BRANCH_ACCOUNT_DOMAINS = 'branch_account_domains';
